import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpRequest, HttpHandler } from '@angular/common/http';

import { Observable } from 'rxjs';


@Injectable()
export class SsoInterceptor implements HttpInterceptor {
  intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const modified = httpRequest.clone({ setHeaders: { sso: `true`, application: 'JS' } });
    return next.handle(modified);
  }
}
